import AlternativeLabelsEditorPage from "@Alternatives/AlternativesLists/Pages/AlternativeLabelsEditorPage.vue";
import AlternativesKanbanPage from "@Alternatives/AlternativesLists/Pages/AlternativesKanbanPage.vue";
import ManageKanbanStatusesPage from "@Alternatives/AlternativesLists/Pages/ManageKanbanStatusesPage.vue";
import RelationshipsPage from "@Alternatives/AlternativesLists/Pages/RelationshipsPage.vue";

export const routes = [
    // Kanban Board
    { path: "/portfolio/kanban/:workspaceId/:projectId/:viewDefId?", component: AlternativesKanbanPage },
    { path: "/decision/kanban/:workspaceId/:projectId/:viewDefId?", component: AlternativesKanbanPage },

    // Manage Alternative Labels
    { path: "/portfolio/alternatives-labels/:workspaceId/:projectId", component: AlternativeLabelsEditorPage },
    { path: "/decision/alternatives-labels/:workspaceId/:projectId", component: AlternativeLabelsEditorPage },

    // Manage Kanban
    { path: "/portfolio/kanban-statuses/:workspaceId/:projectId", component: ManageKanbanStatusesPage },
    { path: "/decision/kanban-statuses/:workspaceId/:projectId", component: ManageKanbanStatusesPage },

    // Manage Dependencies
    { path: "/portfolio/dependencies/:workspaceId/:projectId", component: RelationshipsPage },
    { path: "/decision/dependencies/:workspaceId/:projectId", component: RelationshipsPage },
];

